import styled from 'styled-components';
import Button from '@/components/Button';
export const CountBox = styled.div<{ timeLeft: number }>`
  justify-content: flex-start;
  align-items: center;
  display: flex;
  margin-top: 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: ${({ timeLeft }) => (timeLeft ? '8px' : '12px')};
  @media screen and (max-width: 480px) {
    margin-bottom: 12px;
  }
`;

export const TextBox = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const Title = styled.h2`
  font-size: 20px;
  line-height: 1.4;
  color: #333;
  @media screen and (max-width: 480px) {
    font-size: 18px;
    line-height: 1.33;
  }
`;

export const Description = styled.h3`
  font-size: 14px;
  line-height: 1.29;
  color: #666;
`;

export const Time = styled.h4`
  margin-left: 3px;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: #007c92;
  white-space: nowrap;
`;

export const TimeOver = styled.div`
  font-size: 18px;
  line-height: 1.33;
  color: #e60000;
  display: flex;
  align-items: center;
  gap: 12px;

  &:hover {
    cursor: pointer;
  }
`;

export const ButtonStyled = styled(Button)`
  width: 137px;
  height: 30px;
  padding: 4px 16px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.38;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 24px;
`;
